/* eslint-disable import/prefer-default-export */
export const isInRange = (value, params = { min: 0, max: 0 }) =>
  value >= params.min && value <= params.max;
